import { lazy } from 'react';

const EnergyNeedsContent = import(
  'components/direct-sales/energy-needs/components/EnergyNeedsContent'
);
const EnergyNeedsSidebarRight = import(
  'components/direct-sales/energy-needs/components/EnergyNeedsSidebarRight'
);
const EnergyNeedsHeader = import(
  'components/direct-sales/energy-needs/components/EnergyNeedsHeader'
);
const EnergyNeedsFooter = import(
  'components/direct-sales/energy-needs/components/EnergyNeedsFooter'
);

const EnergyNeeds = {
  Content: lazy(() => EnergyNeedsContent),
  RightSidebar: lazy(() => EnergyNeedsSidebarRight),
  Header: lazy(() => EnergyNeedsHeader),
  Footer: lazy(() => EnergyNeedsFooter)
};

export default EnergyNeeds;
